<template>
    <MenuItemContainer class="image-container"
                       :url="url"
                       noHoverEffects>
        <div v-if="isImageLoading"
             class="purple-placeholder-loading placeholder-loading" />
        <img v-show="!isImageLoading"
             class="image-container__image"
             :src="image_url"
             :alt="image_title"
             :title="image_title"
             @load="isImageLoading = false">
        <NavigationBadge v-if="badge"
                         class="image-container__badge"
                         large
                         :badgeType="badge" />
        <p class="image-container__title">
            {{ title }}
        </p>
        <div v-if="button_title"
             class="image-container__button">
            {{ button_title }}
        </div>
    </MenuItemContainer>
</template>

<script setup lang="ts">
    import { ref } from 'vue';
    import { INavigationImage } from '../types/menuTypes';
    import MenuItemContainer from '../components/MenuItemContainer.vue';
    import NavigationBadge from './navigation-item/NavigationBadge.vue';

    defineProps<INavigationImage>();

    const isImageLoading = ref(false);
</script>

<style scoped lang="scss">
@use "@/sass/partials/variables" as legacyVariables;
@use "@/sass/design-system/variables" as variables;

.image-container {
    position: relative;
    display: flex;
    width: 314px;
    flex-direction: column;
    align-items: center;
    padding-bottom: 10px;
    background: legacyVariables.$white;

    &:hover {
        filter: brightness(1.03);
    }

    &__image {
        max-width: 300px;
        border-radius: legacyVariables.$menu-border-radius;
    }

    &__badge {
        position: absolute;
        top: 8px;
        right: 8px;
    }

    &__title {
        margin-bottom: 10px;
        color: legacyVariables.$black;
        font-size: 13px;
        font-weight: 700;
        text-align: center;
    }

    &__button {
        width: 80%;
        padding: 6px 12px;
        border-radius: legacyVariables.$menu-border-radius;
        background: variables.$primary500;
        color: legacyVariables.$deep-forest-green;
        font-size: 14px;
        font-weight: 700;
        text-align: center;
        text-transform: uppercase;

        &:hover {
            opacity: 0.9;
        }
    }

    .purple-placeholder-loading {
        width: 300px;
        height: 298px;
    }
}

.mobile-nav {
    .purple-placeholder-loading,
    .image-container {
        width: 100%;
    }
}

.dark-theme {
    .image-container {
        &:hover {
            filter: brightness(0.97);
        }
    }
}
</style>
